import RequestFormField from "../model/settings/field"

// import {FieldType} from "../../../../core/fields3/field-type"
// import FieldDropdown from "../../../../core/fields3/generic/dropdown/dropdown"

export function addToFormFields(formFields:any[], requestFormField:RequestFormField, value:any) {

    /*switch (requestFormField.field?.type) {

        case FieldType.DROPDOWN:
            const dropdownField = requestFormField.field as FieldDropdown
            const option = dropdownField._getOption(value)
            if (option) value = option.label
            break

        default:
            break
    }*/

    formFields.push({
        // label   : requestFormField.label,
        value   : value,
        // type    : requestFormField.field?.type,
        config  : requestFormField.formFieldConfig
    })



}